import { PdpDataProvider } from "@/components/pdp/PdpDataContext";
import MegaHeaderV3 from "@/components/home/MegaHeaderV3";
import RiversolFooter from "@/components/pdp/RiversolFooter";
import { EYE_REPAIR_V31 } from "@/data/eyeRepairV31";
import HomeHero from "@/components/home/HomeHero";
import TrustStrip from "@/components/home/TrustStrip";
import HighlightsMarquee from "@/components/home/HighlightsMarquee";
import QuickFinder from "@/components/home/QuickFinder";
import ShopByConcern from "@/components/home/ShopByConcern";
import ShopByConcernClassic from "@/components/home/ShopByConcernClassic";
import BestSellers from "@/components/home/BestSellers";
import NumberProof from "@/components/home/NumberProof";
import DrRiversStory from "@/components/home/DrRiversStory";
import ScienceHinokitiol from "@/components/home/ScienceHinokitiol";
import GuidedDiscovery from "@/components/home/GuidedDiscovery";
import CustomerStories from "@/components/home/CustomerStories";
import CustomerStories2 from "@/components/home/CustomerStories2";
import IngredientSpotlight from "@/components/home/IngredientSpotlight";
import IngredientSpotlightClassic from "@/components/home/IngredientSpotlightClassic";
import RiversolInActionHome from "@/components/home/RiversolInActionHome";
import PressStrip from "@/components/home/PressStrip";
import FinalCta from "@/components/home/FinalCta";
import FaqSection from "@/components/home/FaqSection";
import { GuaranteeBand, GuaranteeStrip } from "@/components/home/GuaranteeBand";

// Riversol Homepage — high-fidelity CRO revamp. Wrapped in `.home-scope`
// so the entire surface (including shared Header + Footer) inherits the
// PDP3.1 sage palette (#0F2E2E) via the scoped CSS override in
// index.css. The `[data-inverted-bg="blue"]` selector in `.home-scope`
// mirrors V3.1's soft-sage footer treatment. Section order follows
// /app/design_guidelines.json.
export default function Home({ marquee = false }) {
  return (
    <PdpDataProvider data={EYE_REPAIR_V31}>
      <div className={`home-scope${marquee ? " hp2" : ""}`}>
        <MegaHeaderV3 />
        <main data-testid="home-page">
          <HomeHero />
          {!marquee && <TrustStrip />}
          <QuickFinder />
          {marquee ? <ShopByConcern /> : <ShopByConcernClassic />}
          {marquee && <HighlightsMarquee />}
          <GuidedDiscovery />
          <BestSellers />
          {marquee && <GuaranteeBand />}
          <NumberProof />
          <DrRiversStory />
          <ScienceHinokitiol />
          <CustomerStories />
          {/* Hidden for now — kept for later. Do not delete. */}
          {/* <CustomerStories2 /> */}
          {marquee ? <IngredientSpotlight /> : <IngredientSpotlightClassic />}
          <PressStrip />
          <RiversolInActionHome />
          {marquee && <FaqSection />}
          {marquee && <GuaranteeStrip />}
          <FinalCta />
        </main>
        <RiversolFooter />
      </div>
    </PdpDataProvider>
  );
}
